import { Button, ButtonGroup, Heading, LuIcon, Text } from "@overmap-ai/blocks"
import { ERROR_MSG_UNEXPECTED } from "@overmap-ai/common"
import type { ErrorComponentProps } from "@tanstack/react-router"
import { memo, useCallback } from "react"

import { ViewContainer } from "../../components/Containers/ViewContainer"
import { modelIconMapping } from "../../mappings/icons"
import { sdk } from "../../sdk"

export const DefaultErrorBoundaryView = memo<ErrorComponentProps>((props) => {
	const { error, reset } = props

	// const handleReportError = useCallback(() => {
	// 	// TODO: implement
	// }, [])

	const handleSignout = useCallback(() => {
		reset()
		void sdk.main.logout()
	}, [reset])

	return (
		<ViewContainer className="relative z-[10000]">
			<div className="flex size-full items-center justify-center">
				<div className="flex size-full max-w-xs flex-col items-center justify-center gap-4">
					<div className="flex flex-col gap-1">
						<Heading size="xl">{ERROR_MSG_UNEXPECTED}</Heading>
						<Text accentColor="base">{error.message}</Text>
					</div>

					<ButtonGroup className="flex w-full items-center gap-2" size="md" variant="surface">
						{/*<Button onClick={handleReportError} className="shirnk-1! grow basis-0">*/}
						{/*	<LuIcon icon={modelIconMapping.alertCircle} />*/}
						{/*	Report*/}
						{/*</Button>*/}

						{/*<Separator size="sm" orientation="vertical" />*/}

						<Button onClick={handleSignout} className="shirnk-1! grow basis-0">
							<LuIcon icon={modelIconMapping.exit} />
							Sign out
						</Button>
					</ButtonGroup>
				</div>
			</div>
		</ViewContainer>
	)
})
DefaultErrorBoundaryView.displayName = "DefaultErrorBoundaryView"
